import { api } from '../../apiClient';

// Transaction API service functions
export const transactionService = {
  // Get all transactions
  getAllTransactions: async () => {
    const response = await api.get('/transaction');
    return response.data;
  },

  // Get transaction by ID
  getTransactionById: async (transactionId) => {
    const response = await api.get(`/transaction/${transactionId}`);
    return response.data;
  },

  // Create transaction
  createTransaction: async (transactionData) => {
    const response = await api.post('/transaction', transactionData);
    return response.data;
  },

  // Update transaction
  updateTransaction: async (transactionId, transactionData) => {
    const response = await api.put(`/transaction/${transactionId}`, transactionData);
    return response.data;
  },

  // Delete transaction
  deleteTransaction: async (transactionId) => {
    const response = await api.delete(`/transaction/${transactionId}`);
    return response.data;
  },
};

export default transactionService;
